import get from 'lodash/get'
import makeDebug from 'debug'
import axios from 'axios'
import wcs from '@/scripts/libs/wcs'

import { N } from '@/scripts/constants/booleans'

import { MINIWISHLIST_SAVED } from '@/scripts/constants/cookies'
import { Cookies } from '@/scripts/libs/cookies'

const debug = makeDebug('wcs:wishlist')

// TODO: these headers are added to ALL requests and break manifest.json because they force a preflight
//// Important for invalidating cache on IE11

interface WcsRemoveProductFromWishlist {
  wishlistItemId: number
  wishListId: number
  roxSet: any
  configurationId: number
}

interface AddToWishlistParams {
  catalogId: string
  storeId: string
  langId: string
  catEntryId?: string | number
}

export class WcsWishlist {
  static get = async () => {
    const { catalogId, storeId, langId } = wcs.getStoreConfig()
    const addToWishlistUrl = wcs.getEndPoint('miniWishlist')

    const response = await axios.get(addToWishlistUrl, {
      params: {
        catalogId: catalogId,
        storeId: storeId,
        langId: langId,
      },
    })

    debug('WcsWishlist.getMiniwishlist %o', response)

    Cookies.set(MINIWISHLIST_SAVED, true)
    sessionStorage.setItem(MINIWISHLIST_SAVED, JSON.stringify(response.data.wishLists))

    return get(response, 'data.wishLists', {})
  }

  static removeProduct = async ({
    wishlistItemId,
    wishListId,
    roxSet,
    configurationId,
  }: WcsRemoveProductFromWishlist) => {
    const { catalogId, storeId, langId } = wcs.getStoreConfig()
    const removeFromWishlistUrl = wcs.getEndPoint('removeFromWishlist')
    let params = null

    if (roxSet && configurationId) {
      //rox case
      params = {
        catalogId: catalogId,
        storeId: storeId,
        langId: langId,
        doInventory: N,
        catEntryId: wishlistItemId,
        listId: wishListId,
        isOnlyRemoveFromStar: true,
        roxSet: roxSet,
        configurationId: configurationId,
      }
    } else if (!roxSet && configurationId) {
      //remix case
      params = {
        catalogId: catalogId,
        storeId: storeId,
        langId: langId,
        doInventory: N,
        catEntryId: wishlistItemId,
        listId: wishListId,
        isOnlyRemoveFromStar: true,
        configurationId: configurationId,
      }
    } else {
      //normal case
      params = {
        catalogId: catalogId,
        storeId: storeId,
        langId: langId,
        doInventory: N,
        catEntryId: wishlistItemId,
        listId: wishListId,
        isOnlyRemoveFromStar: true,
      }
    }
    const response = await axios.get(removeFromWishlistUrl, {
      params,
    })

    return response.data
  }

  static addProduct = async ({ catEntry }: { catEntry: number }) => {
    const { catalogId, storeId, langId } = wcs.getStoreConfig()
    const addToWishlistUrl = wcs.getEndPoint('addToWishlist')

    const params: AddToWishlistParams = {
      catalogId: catalogId,
      storeId: storeId,
      langId: langId,
    }
    if (typeof catEntry === 'object') {
      Object.assign(params, catEntry)
    } else {
      params.catEntryId = catEntry
    }
    const response = await axios.get(addToWishlistUrl, { params })
    return response.data
  }
}
